import React, { useContext, useEffect, useState } from "react";
import {
  Grid,
  Segment,
  Form,
  Button,
} from "semantic-ui-react";
import TechnicianCertificateList from "./TechnicianCertificateList";
import { observer } from "mobx-react-lite";
import TechnicianCertificateStore from "../../../app/stores/techniciancertificateStore";
import EmployeeCertificateStore from "../../../app/stores/employeecertificateStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { Link, RouteComponentProps } from "react-router-dom";

interface DetailParams {
  expiry: string;
}

const TechnicianCertificateDashboard: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history
}) => {
  const techniciancertificateStore = useContext(TechnicianCertificateStore);
  const {
    createTechnicianCertificate,
    editTechnicianCertificate,
    submitting,
    techniciancertificate: initialFormState,
    loadTechnicianCertificates,
    loadTechnicians,
    techniciansByName,
    loadCertificates,
    certificatesByName,
    searchTechnicianCertificates,
    clearTechnicianCertificate,
    clearTechnicianCertificates,
    loadTechnicianCertificateZipFile,
  } = techniciancertificateStore;
  const employeecertificateStore = useContext(EmployeeCertificateStore);
  const {
    uploadingFile,
  } = employeecertificateStore;

  useEffect(() => {
    loadTechnicians();
    loadCertificates();
    if (match.params.expiry) searchTechnicianCertificates(search);

    return () => {
      clearTechnicianCertificates()
    }
  }, []);

  const [search, setSearch] = useState({
    technicianemail: "",
    certone: "",
    certtwo: "",
    certthree: "",
    expiry: match.params.expiry,
  });

  if (techniciancertificateStore.loadingInitial)
    return <LoadingComponent content="Loading TechnicianCertificates" />;

    if (uploadingFile) return <LoadingComponent content='Uploading photos...' />

  const technicianOptions = techniciansByName.map(function (tech) {
    var option = { key: tech.id, text: tech.name, value: tech.email };
    return option;
  });

  const certificateOptions = certificatesByName.map(function (cert) {
    var option = { key: cert.id, text: cert.name, value: cert.id };
    return option;
  });

  const expiryOptions = [
    { key: "expired", text: "Expired", value: "expired" },
    { key: "onemonth", text: "Within One Month", value: "onemonth" },
    { key: "threemonth", text: "Within Three Month", value: "threemonth" },
  ];

  const handleSubmit = () => {
    searchTechnicianCertificates(search);
  };

  return (
    <Segment>
      <Grid>
        <Grid.Column>
          <Form onSubmit={handleSubmit}>
            <Form.Select
              label="Name"
              onChange={(e, { name, value }) =>
                setSearch({ ...search, [name]: value })
              }
              options={technicianOptions}
              search
              name="technicianemail"
              placeholder="Name"
              value={search.technicianemail}
              width={3}
              clearable
            />
            <Form.Group widths="equal">
              <Form.Select
                label="Certificate"
                onChange={(e, { name, value }) =>
                  setSearch({ ...search, [name]: value })
                }
                options={certificateOptions}
                search
                name="certone"
                placeholder="Certificate"
                value={search.certone}
                clearable
              />

              <p>
                <h5 style={{marginTop: '2.2rem'}}>&amp; </h5>
              </p>
              <Form.Select
                label="Certificate"
                onChange={(e, { name, value }) =>
                  setSearch({ ...search, [name]: value })
                }
                options={certificateOptions}
                search
                name="certtwo"
                placeholder="Certificate"
                value={search.certtwo}
                clearable
              />

              <p>
                <h5 style={{marginTop: '2.2rem'}}>&amp; </h5>
              </p>
              <Form.Select
                label="Certificate"
                onChange={(e, { name, value }) =>
                  setSearch({ ...search, [name]: value })
                }
                options={certificateOptions}
                search
                name="certthree"
                placeholder="Certificate"
                value={search.certthree}
                clearable
              />
            </Form.Group>
            <Form.Select
              label="Expiry Date"
              width={3}
              onChange={(e, { name, value }) =>
                setSearch({ ...search, [name]: value })
              }
              options={expiryOptions}
              search
              name="expiry"
              placeholder="Expiry Date"
              value={search.expiry}
              clearable
            />
            <Button
              floated="left"
              positive
              type="submit"
              content="Search"
            />
          </Form>
        </Grid.Column>
      </Grid>
      <Grid> 
      <Grid.Column width={13}>
      <Button
            onClick={() => loadTechnicianCertificateZipFile(search.technicianemail).then((url) => window.open(url))}
            color="grey"
            icon="download"
            content="Download All"
          />
      </Grid.Column>
        <Grid.Column textAlign="center" width={3}>
          <Button
            as={Link}
            to={`/hrmanagement/techniciancertificate-create/ `}
            color="linkedin"
            icon="add"
            content="Create New"
          />
        </Grid.Column>
      </Grid>
      <Grid>
        <Grid.Column>
          <TechnicianCertificateList />
        </Grid.Column>
      </Grid>
    </Segment>
  );
};

export default observer(TechnicianCertificateDashboard);
